export interface TimeAgoInfo {
  daysAgo: number;
  timeAgo: string;
}

export function calculateTimeAgo(dateString: string): TimeAgoInfo | null {
  const inputDate = new Date(dateString);

  if (isNaN(inputDate.getTime())) {
    // console.error("Invalid date string.");
    return null;
  }

  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - inputDate.getTime();
  const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24));

  let timeAgo: string;

  if (daysAgo < 1) {
    timeAgo = "today";
  } else if (daysAgo >= 30) {
    const monthsAgo = Math.floor(daysAgo / 30);
    timeAgo = `${monthsAgo} month${monthsAgo > 1 ? "s" : ""} ago`;
  } else if (daysAgo >= 7) {
    const weeksAgo = Math.floor(daysAgo / 7);
    timeAgo = `${weeksAgo} week${weeksAgo > 1 ? "s" : ""} ago`;
  } else {
    timeAgo = `${daysAgo} day${daysAgo > 1 ? "s" : ""} ago`;
  }

  return {
    daysAgo,
    timeAgo,
  };
}
